export interface Item {
    price: number;
}

export const calculateTotal = (items: Item[]) => {
    return items.map((m) => m.price).reduce((acc, cur) => acc + cur, 0);
};
